// Typelizer digest 289ab76949da0e00e5bb8a2db3162a19
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/payments/:payment_id/category_takeover */
  create: (
    params: { paymentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/payments/:payment_id/category_takeover', params, options),
    method: 'post',
  }),
}
